/**
 * @desc 分页
 */
const URL = "/rantion-report";
import http, { updateResponse } from "@/http";
export function request(params: API.report.fileDownloadTaskRecord.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/fileDownloadTaskRecord/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
